// Modal.js
import React, { useEffect, useState } from 'react';
import './Modal.css';

const Modal = () => {
  const [showModal, setShowModal] = useState(false);

  // Check sessionStorage and show modal if it's the first visit
  useEffect(() => {
    const hasModalShown = sessionStorage.getItem('modalShown');
    if (!hasModalShown) {
      setShowModal(true);
      sessionStorage.setItem('modalShown', 'true');
    }
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    showModal && (
      <div className="modal-overlay">
        <div className="modal-content">
        <img src={process.env.PUBLIC_URL + "/assets/img/popup.webp"} className="modal-image" alt="popup advert" />
        <div className="close-btn" onClick={closeModal}>✖</div> {/* Close "X" */}
        </div>
      </div>
    )
  );
};

export default Modal;
